<script>
export default {
    name: "RadiologyResultsPrint",

    data() {

        return {
            patient: {},
            investigation: {},
            investigationResult: {},
            printTime: window.moment(),
        };
    },

    mounted() {
        this.$root.loading=true;
        Promise.all([ 
                this.fetchPatient(), this.fetchInvestigation(), this.fetchInvestigationResult(), 
            ]).then(() => {
            this.$root.loading=false;
            setTimeout(() => {
                window.print();
            }, 250);
        }).catch(() => {this.$root.loading=false;});
    },

    methods: {

        fetchPatient() {
            let url = `PatientRegistration/GetSpecificPatient`;
                url += `?PatientID=${this.$route.params.patientID}`;

            return this.$http.get(url).then(response => {
                this.patient = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },

        fetchInvestigationResult() {
            let url = `Radiology/GetCompletedRadiologyResult`;
                url += `?PatientLabResultId=${this.$route.params.labResultID}`;

            return this.$http.get(url).then(response => {
                this.investigationResult = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },

        fetchInvestigation() {
            let url = `MedicalFile/GetSpecificPatientInvestigationTreatment`;
                url += `?InvestigationID=${this.$route.params.labResultID}`;
            return this.$http.get(url).then(response => {
                this.investigation = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },
    },
}
</script>
<template>
<div class="flex flex-wrap p-tiny">
    <tail-address-header></tail-address-header>
    <div class="w-full flex flex-wrap p-1 my-1 border-b-2 border-t-2 border-gray-800">
        <div class="w-1/3">
            <h5 class="text-base">
                <span class="font-medium">Name:</span> {{ patient.names }}</h5>
        </div>
        <div class="flex-1">
            <h5 class="text-base">
                <span class="font-medium">Visit No:</span> {{ patient.visitNo || `-` }}</h5>
        </div>
        <div class="flex-1">
            <h5 class="text-base">
                <span class="font-medium">MRN:</span> {{ patient.patienT_ID }}</h5>
        </div>
    </div>
    <div class="w-full flex flex-wrap p-1 border-t-2 border-b-2 border-gray-700 my-1">
        <div class="w-1/3 p-1">
            <h5 class="text-base">
                <span class="font-medium">Investigation:</span> 
                    {{ investigation.investigation }}</h5>
        </div>
         <div class="w-1/3 p-1">
            <h5 class="text-base">
                <span class="font-medium">Accession No:</span> 
                    {{ investigation.code }}</h5>
        </div>
        <div class="w-1/3 p-1">
            <h5 class="text-base">
                <span class="font-medium">Requested By:</span> 
                    {{ investigation.requestedBy || `-` }}</h5>
        </div>
        <div class="w-1/3 p-1">
            <h5 class="text-base">
                <span class="font-medium">Date Requested:</span> 
                    {{ investigation.date | dateFormat }}</h5>
        </div>
        <div class="w-1/3 p-1">
            <h5 class="text-base">
                <span class="font-medium">Done By:</span> 
                    {{ investigation.userName }}</h5>
        </div>
        <div class="w-1/3 p-1">
            <h5 class="text-base">
                <span class="font-medium">Date Done:</span> 
                    {{ investigationResult.sysDate | dateFormat }}</h5>
        </div>
        <!-- <div class="w-1/3 p-1">
            <h5 class="text-base">
                <span class="font-medium">Printed On:</span> 
                    {{ printTime | dateFormat }}</h5>
        </div> -->
    </div>
    <div class="my-1">
        <h5 class="text-base p-tiny">Notes:</h5>
        <span v-html="investigationResult.results"></span>
    </div>
    <tail-stamp></tail-stamp>
</div>
</template>